export default __webpack_public_path__ + "static/media/logo.41810679.png";